import React, { FunctionComponent } from 'react';
import { SIZE_250_250 } from '../../constants/imageTemplateStrings';
import styles from './FundraiserCard.scss';
import {
  FundraiserTotals,
  FundraiserTotalsProps,
} from '../FundraiserTotals/FundraiserTotals';
import Avatar from '@justgiving/avatar';
import { makePhotoUrlFromAbsoluteUrl } from '../../utils/makePhotoUrl';
import config from '../../client/config';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

type FundraiserCardProps = {
  pageTitle: string;
  ownerName?: string;
  ownerAvatarImageUrl?: string;
  pageImageUrl: string;
  pageSlug: string;
} & FundraiserTotalsProps;

export const FundraiserCard: FunctionComponent<FundraiserCardProps> = ({
  pageTitle,
  ownerName,
  ownerAvatarImageUrl,
  pageImageUrl,
  pageSlug,
  targetAmount,
  raisedAmount,
  currencyCode,
  supporterCount,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <li data-qa="fundraiser-card" className={styles.card}>
      <img
        data-qa="fundraiser-card-page-image"
        className={styles.card_image}
        src={`${pageImageUrl}?template=${SIZE_250_250}`}
        alt=""
      />
      <div className={styles.card_content_wrapper}>
        <a
          className={classnames('jg-h4', styles.link)}
          href={`${config.baseUri}/fundraising/${pageSlug}`}
          data-track="fundraiser-card-title-link"
        >
          <span className="jg-sr-only">
            {t('fundraiserCard.fundraisingPageTitle')}
          </span>
          {pageTitle}
        </a>
        <div className={styles.fundraiser_details}>
          <Avatar
            avatarSize="medium"
            picture={
              ownerAvatarImageUrl
                ? makePhotoUrlFromAbsoluteUrl(ownerAvatarImageUrl)
                : undefined
            }
          />
          <p className={classnames('jg-h6', styles.fundraiser_name)}>
            <span className="jg-sr-only">
              {t('fundraiserCard.fundraisingPageOwner')}
            </span>
            {ownerName}
          </p>
        </div>
        <FundraiserTotals
          targetAmount={targetAmount}
          currencyCode={currencyCode}
          raisedAmount={raisedAmount}
          supporterCount={supporterCount}
        />
      </div>
    </li>
  );
};
